import styled from 'styled-components'

export const Container = styled.div`  
  position:relative;
  display:flex;
  flex-flow:column noWrap;
  flex:1;
  height:100vh;
  box-sizing: border-box;  
  background-color:tomato;
  justify-content:space-between;
  align-items:center;
  --background-image: url('image/fundoTela01.jpg');
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #1594a5; 
  overflow:hidden;  
`
export const Title = styled.span`
  display:flex;
  flex-flow: row wrap;
  width:100%;
  color: #FFF;
  margin-bottom:4px; 
`

export const ContainerImage = styled.div`
  
  display:flex;  
  top:0px;
  width:100%;
  height:80px;
  justify-content:center;
  align-items:center;  

  @media (min-width: 800px) 
  {
    height:160px;
  } 

  @media (min-width: 700px) 
  {
    height:150px;
  } 
`

export const Image = styled.img`
  width: 40%;

  @media (min-width: 800px) 
  {
    width: 30%;
  } 
`

export const ImageMapa = styled.img`
  width: 60px;
  height: 40px;
  margin-top: 8px;
  margin-left: 5px;
`

export const ContainerTitle = styled.div`
  
  display:flex;  
  top:0px;
  width:100%;
  height:80px;
  justify-content:center;
  align-items:center;  

  @media (min-width: 800px) 
  {
    height:160px;
  } 

  @media (min-width: 700px) 
  {
    height:150px;
  } 
`

export const HeaderTitle = styled.span`
  margin-top: 0px;
  font-weight: bold;
  font-size: 26px;
  color: #FFF;
`

export const ContainerSelect = styled.div`
  display:block;
  width:90%;

`

export const ContainerField = styled.div`
  margin-top: 10px;
  width: 100%;
  
`
export const ContainerFieldLocation = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;  
`


export const SubContainerField = styled.div`
  margin-top: 10px;
  width: 100%;
`


export const SubContainerButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: row;
  margin-top: 10px;
  width: 90%;
  margin: 3px;
`



export const ContainerContent = styled.div`
  display:flex;
  flex-flow: row wrap;
  justify-content:center;
  align-items:center;
  width:90%;  
  margin:3px;
  margin-top: 10px;
`
export const ContainerHeader = styled.div`
  display:flex;
  flex-flow: row wrap;
  justify-content:center;
  align-items:center;
  flex-direction: column;
  width:90%;  
  margin:3px;
  margin-top: 10px;
`
export const SubHeaderTitle = styled.span`
  font-weight: bold;
  font-size: 16px;
  color: #FFF;
`


export const ContainerIcons = styled.div`
  position:absolute;
  display:flex;
  bottom: 0px;
  right:0px;
  padding:10px;
  font-size:1.5em;
  color:#f7f7f7;
`

export const Label = styled.div`
  display:flex;
  flex-flow: row wrap;
  width:100%;
  color: #FFF;
  margin-bottom:4px; 
  
`
